var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { createUseStyles } from "react-jss";
import { Button } from "../../Button";
import { DraggableFormRow, NewFormRow, StaticFormRow } from "./FormBuilderRow";
import { FormHeader } from "./FormBuilderHeader";
import { FormStateStatus } from "../../utils/FormStateStatus";
import { classNames } from "../../utils/classNames";
var styles = {
    table: {
        paddingBottom: "12px",
    },
    body: {
        "& form:nth-child(odd)": {
            background: "#F3F9FC",
        },
    },
    row: {
        display: "flex",
    },
    cell: {
        flex: "4 4 0",
        padding: "4.5px 5px 4px 5px",
        borderBottom: "1px solid #D5DFE7",
        "& .select__single-value": {
            top: "45%",
        },
        "& .form-group": {
            marginBottom: 0,
        },
        "& .form-control-static": {
            minHeight: "initial",
            paddingBottom: 0,
        },
        minHeight: 30,
    },
    rowDragging: {
        borderTop: "1px solid #D5DFE7",
        backgroundColor: "#fff",
    },
    header: {
        fontWeight: "400",
        borderStyle: "hidden",
        background: "#1d6dc0",
        color: "#ffffff",
        padding: "0 5px 0 5px",
        "&:first-child": {
            borderRight: "none",
        },
        "&:last-child": {
            borderLeft: "none",
        },
        borderTop: "1px solid #165494",
        minHeight: 30,
        lineHeight: "30px",
    },
    action: {
        flex: 1,
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        "& .btn-link": {
            padding: "0",
        },
    },
    actionBody: {
        borderLeft: "1px solid #D5DFE7",
        borderRight: "1px solid #D5DFE7",
    },
    dragHandle: {
        maxWidth: "60px",
        color: "#566F80",
    },
    disabled: {
        color: "#D5DFE7",
    },
    actionWrapper: {
        display: "flex",
        position: "relative",
        justifyContent: "center",
        "& .form-group": {
            marginBottom: "0",
        },
        "& .form-group + .btn, .btn + .btn, .btn + .opacity-overlay + .opacity-overlay--content > .btn": {
            marginLeft: "8px",
        },
        "& .glyphicon-pro": {
            fontSize: 18,
        },
    },
    actionLast: { minWidth: 92 },
    dragHandleWrapper: { whiteSpace: "nowrap" },
};
export var useFormBuilderStyles = createUseStyles(styles);
function reorder(list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
}
export function FormBuilder(_a) {
    var _this = this;
    var columns = _a.columns, staticRows = _a.staticRows, rows = _a.rows, onRowAdd = _a.onRowAdd, onRowUpdate = _a.onRowUpdate, onRowDelete = _a.onRowDelete, onRowReorder = _a.onRowReorder, messages = _a.messages, saveState = _a.saveState, _b = _a.entityName, entityName = _b === void 0 ? "Field" : _b, id = _a.id;
    var classes = useFormBuilderStyles();
    var _c = useState(false), isAdding = _c[0], setIsAdding = _c[1];
    var _d = useState(null), editIndex = _d[0], setEditIndex = _d[1];
    useEffect(function () {
        if (saveState === "saved") {
            setEditIndex(null);
            setIsAdding(false);
        }
    }, [saveState]);
    var onUpdate = function (values) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onRowUpdate(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onAdd = function (values) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onRowAdd(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onUpdateCancel = function () { return setEditIndex(null); };
    var onAddCancel = function () { return setIsAdding(false); };
    var onReorder = function (result) { return __awaiter(_this, void 0, void 0, function () {
        var items;
        return __generator(this, function (_a) {
            if (!result.destination ||
                result.destination.index === result.source.index) {
                return [2 /*return*/];
            }
            items = reorder(rows, result.source.index, result.destination.index);
            onRowReorder(items);
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormStateStatus, { saveState: saveState, messages: messages }),
        React.createElement("div", { className: classNames(classes.table), role: "grid", id: id },
            React.createElement(FormHeader, { columns: columns }),
            React.createElement(DragDropContext, { onDragEnd: onReorder },
                React.createElement(Droppable, { droppableId: "droppable-1" }, function (provided) { return (React.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef, className: classNames(classes.body) }),
                    staticRows.map(function (row, index) { return (React.createElement(StaticFormRow, { key: "static-".concat(index), columns: columns, row: row })); }),
                    rows.map(function (row, index) { return (React.createElement(DraggableFormRow, { key: row.id, columns: columns, row: row, index: index, onSubmit: onUpdate, onEdit: function () { return setEditIndex(index); }, onCancel: onUpdateCancel, onDelete: function () { return onRowDelete(row); }, isEditing: index === editIndex, actionsDisabled: (editIndex !== null && editIndex !== index) || isAdding, loading: saveState === "saving" })); }),
                    provided.placeholder,
                    isAdding && (React.createElement(NewFormRow, { columns: columns, rows: rows, onSubmit: onAdd, onCancel: onAddCancel, loading: saveState === "saving" })))); }))),
        React.createElement(Button, { label: "Add ".concat(entityName), type: "primary", onClick: function () { return setIsAdding(true); }, disabled: editIndex !== null || isAdding, ariaLabel: "Add ".concat(entityName) })));
}
